import { render, staticRenderFns } from "./Method.vue?vue&type=template&id=44a2b18d&scoped=true"
import script from "./Method.vue?vue&type=script&lang=ts"
export * from "./Method.vue?vue&type=script&lang=ts"
import style0 from "./Method.vue?vue&type=style&index=0&id=44a2b18d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a2b18d",
  null
  
)

export default component.exports